import type { Post } from "@/lib/sanity";
import { ArticleItem } from "./articleItem";
import { cn } from "@/lib/utils";

type ArticleListProps = {
  posts: Post[];
  onNavigate: (path: string) => void;
  className?: string;
};

export function ArticleList({ posts, onNavigate, className }: ArticleListProps) {
  if (posts.length === 0) {
    return (
      <div className={cn("py-16 text-center", className)}>
        <p className="text-muted-foreground">記事はまだありません。</p>
      </div>
    );
  }

  return (
    <ul
      className={cn(
        "grid gap-8 sm:grid-cols-2 lg:grid-cols-3",
        className,
      )}
      role="list"
    >
      {posts.map((post) => (
        <li key={post._id}>
          <ArticleItem post={post} onNavigate={onNavigate} />
        </li>
      ))}
    </ul>
  );
}
